import React from "react";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";

const IOSSwitch = (props) => (
  <Switch
    focusVisibleClassName=".Mui-focusVisible"
    disableRipple
    sx={{
      width: 30,
      height: 18,
      padding: 0,
      "& .MuiSwitch-switchBase": {
        padding: 0,
        margin: "2px",
        transitionDuration: "300ms",
        "&.Mui-checked": {
          transform: "translateX(12px)",
          color: "#fff",
          "& + .MuiSwitch-track": {
            backgroundColor: "rgba(70, 160, 145, 1)",
            opacity: 1,
            border: 0,
          },
          "&.Mui-disabled + .MuiSwitch-track": {
            opacity: 0.5,
          },
        },
        "&.Mui-focusVisible .MuiSwitch-thumb": {
          color: "rgba(70, 160, 145, 1)",
          border: "6px solid #fff",
        },
      },
      "& .MuiSwitch-thumb": {
        boxSizing: "border-box",
        width: 14,
        height: 14,
        backgroundColor: "#fff",
      },
      "& .MuiSwitch-track": {
        borderRadius: 14 / 2,
        backgroundColor: "#E9E9EA",
        opacity: 1,
        transition: "background-color 500ms",
        ...props.switchTrackStyles,
      },
    }}
    {...props}
  />
);

const CustomSwitch = ({ checked, onChange, switchTrackStyles }) => {
  return (
    <FormControlLabel
      sx={{ mr: "0px" }}
      control={
        <IOSSwitch
          checked={checked}
          onChange={onChange}
          switchTrackStyles={switchTrackStyles}
        />
      }
    />
  );
};

export default CustomSwitch;
